/* Polite Society collection — filters / sort / load-more / grid toggle (section re-render) */
(function () {
  function init(root) {
    if (root.dataset.psBound) return;
    root.dataset.psBound = '1';
    var sectionId = root.dataset.sectionId;
    var gridWrap = root.querySelector('#ProductGridContainer');
    var filter = root.querySelector('[data-ps-filter]');
    var form = root.querySelector('[data-ps-filter-form]');
    var sort = root.querySelector('[data-ps-sort]');
    var sortValue = root.querySelector('[data-ps-sort-value]');
    var count = root.querySelector('#ProductCount');
    var filterCount = root.querySelector('[data-ps-filter-count]');
    var timer;

    /* ---------- keep the grid to whole rows while more pages are waiting ----------
       Colour-split cards mean a page can render a card count that isn't a multiple of
       the column count, which left a half-empty row sitting above "Load more".
       Park the trailing cards until the next page is appended (or until this is the
       last page, when the short row is simply the end of the collection). */
    function tidyRows() {
      var list = root.querySelector('[data-ps-grid-list]');
      if (!list) return;
      var items = Array.prototype.slice.call(list.querySelectorAll('.ps-grid__item'));
      items.forEach(function (li) { li.classList.remove('is-row-pad'); });
      if (!root.querySelector('[data-ps-load-more]') || !items.length) return;
      var cols = (getComputedStyle(list).gridTemplateColumns || '').split(' ').filter(Boolean).length;
      if (cols < 2) return;
      var rem = items.length % cols;
      for (var i = 0; i < rem; i++) items[items.length - 1 - i].classList.add('is-row-pad');
    }
    var tidyTimer;
    window.addEventListener('resize', function () { clearTimeout(tidyTimer); tidyTimer = setTimeout(tidyRows, 150); });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ps-grid]')) setTimeout(tidyRows, 0);
    });

    /* ---------- grid density toggle ---------- */
    var saved = null;
    try { saved = localStorage.getItem('ps-grid-view'); } catch (e) {}
    function setView(v) {
      root.dataset.view = v;
      root.querySelectorAll('[data-ps-grid]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.psGrid === v); });
      try { localStorage.setItem('ps-grid-view', v); } catch (e) {}
    }
    if (saved === 'small') setView('small');
    root.querySelectorAll('[data-ps-grid]').forEach(function (b) {
      b.addEventListener('click', function () { setView(b.dataset.psGrid); });
    });

    /* ---------- drawer ---------- */
    var filterOpener = null;
    function openFilter(e) {
      if (!filter) return;
      filterOpener = (e && e.currentTarget) || document.activeElement;
      filter.classList.add('is-open'); filter.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ps-filter-open');
      root.querySelectorAll('[data-ps-filter-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var c = filter.querySelector('[data-ps-filter-close]'); if (c) c.focus();
    }
    function closeFilter() {
      if (!filter || !filter.classList.contains('is-open')) return;
      filter.classList.remove('is-open'); filter.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ps-filter-open');
      root.querySelectorAll('[data-ps-filter-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (filterOpener && filterOpener.focus && document.contains(filterOpener)) filterOpener.focus();
    }
    /* keep Tab inside the panel while it is open */
    filter && filter.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !filter.classList.contains('is-open')) return;
      var list = Array.prototype.filter.call(
        filter.querySelectorAll('button, [href], input, select, textarea, summary, [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null && !el.disabled; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    root.querySelectorAll('[data-ps-filter-open]').forEach(function (b) { b.addEventListener('click', openFilter); });
    root.querySelectorAll('[data-ps-filter-close]').forEach(function (b) { b.addEventListener('click', closeFilter); });
    /* one listener for the life of the page — init() runs again on section reload */
    if (!window.__psFilterEsc) {
      window.__psFilterEsc = true;
      document.addEventListener('keyup', function (e) {
        if (e.key !== 'Escape') return;
        var open = document.querySelector('.ps-filter.is-open [data-ps-filter-close]');
        if (open) open.click();
      });
    }

    /* ---------- fetch + render ---------- */
    function buildParams() {
      var params = new URLSearchParams();
      if (form) {
        new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      }
      if (sort && sort.value) { params.delete('sort_by'); params.append('sort_by', sort.value); }
      // keep chip (product type) filter from the URL if the form doesn't carry it
      var current = new URLSearchParams(window.location.search);
      if (!params.has('filter.p.product_type') && current.has('filter.p.product_type') && !(form && form.querySelector('[name="filter.p.product_type"]'))) {
        current.getAll('filter.p.product_type').forEach(function (v) { params.append('filter.p.product_type', v); });
      }
      return params.toString();
    }

    var reqSeq = 0;
    function render(params, push) {
      root.classList.add('is-loading');
      var mine = ++reqSeq;
      var url = window.location.pathname + '?section_id=' + sectionId + (params ? '&' + params : '');
      fetch(url).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(function (html) {
        /* a slower earlier request must not overwrite a newer one */
        if (mine !== reqSeq) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('#ProductGridContainer');
        if (newGrid && gridWrap) gridWrap.innerHTML = newGrid.innerHTML;
        var newCount = doc.querySelector('#ProductCount');
        if (newCount && count) count.innerHTML = newCount.innerHTML;
        var newFC = doc.querySelector('[data-ps-filter-count]');
        if (newFC && filterCount) filterCount.innerHTML = newFC.innerHTML;
        var newGroups = doc.querySelector('[data-ps-filter-groups]');
        var groups = root.querySelector('[data-ps-filter-groups]');
        if (newGroups && groups) {
          // preserve open/closed state
          var openState = {};
          groups.querySelectorAll('details').forEach(function (d, i) { openState[i] = d.open; });
          groups.innerHTML = newGroups.innerHTML;
          groups.querySelectorAll('details').forEach(function (d, i) { if (openState[i] !== undefined) d.open = openState[i]; });
        }
        var newChips = doc.querySelector('[data-ps-chips]');
        var chips = root.querySelector('[data-ps-chips]');
        if (newChips && chips) chips.innerHTML = newChips.innerHTML;
        var newSortVal = doc.querySelector('[data-ps-sort-value]');
        if (newSortVal && sortValue) sortValue.textContent = newSortVal.textContent;
        /* keep the control itself in step, or a back navigation leaves a stale sort
           that the next filter change silently re-applies */
        var newSort = doc.querySelector('[data-ps-sort]');
        if (newSort && sort) sort.value = newSort.value;
        if (push) history.pushState({ psParams: params }, '', window.location.pathname + (params ? '?' + params : ''));
        markChips();
        if (window.psCardInit) window.psCardInit(root);
        if (window.psWishlist && window.psWishlist.sync) window.psWishlist.sync(root);
        tidyRows();
        root.classList.remove('is-loading');
      }).catch(function () { if (mine === reqSeq) root.classList.remove('is-loading'); });
    }

    if (form) {
      form.addEventListener('input', function (e) {
        clearTimeout(timer);
        var wait = e.target.type === 'number' ? 700 : 150;
        timer = setTimeout(function () { render(buildParams(), true); }, wait);
      });
      var clear = form.querySelector('[data-ps-filter-clear]');
      if (clear) clear.addEventListener('click', function (e) {
        e.preventDefault();
        form.querySelectorAll('input[type=checkbox]').forEach(function (c) { c.checked = false; });
        form.querySelectorAll('input[type=number]').forEach(function (c) { c.value = ''; });
        render(buildParams(), true);
      });
    }
    if (sort) sort.addEventListener('change', function () { render(buildParams(), true); });

    window.addEventListener('popstate', function (e) {
      var params = (e.state && e.state.psParams !== undefined) ? e.state.psParams : window.location.search.replace(/^\?/, '');
      render(params, false);
    });

    /* ---------- chips (product-type filter, single select) ---------- */
    function markChips() {
      var chips = root.querySelectorAll('[data-chip]');
      if (!chips.length) return;
      var types = new URLSearchParams(window.location.search).getAll('filter.p.product_type');
      chips.forEach(function (c) {
        var v = c.dataset.chip;
        c.classList.toggle('is-active', v === '' ? types.length === 0 : types.indexOf(v) > -1);
      });
    }
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-chip]');
      if (!chip) return;
      e.preventDefault();
      var type = chip.dataset.chip;
      // optimistic highlight so the tab moves instantly
      root.querySelectorAll('[data-chip]').forEach(function (c) { c.classList.toggle('is-active', c === chip); });
      if (form) {
        form.querySelectorAll('input[name="filter.p.product_type"]').forEach(function (c) { c.checked = (c.value === type); });
      }
      var params = new URLSearchParams(buildParams());
      params.delete('filter.p.product_type');
      if (type) params.append('filter.p.product_type', type);
      render(params.toString(), true);
    });

    /* ---------- load more ---------- */
    root.addEventListener('click', function (e) {
      var more = e.target.closest('[data-ps-load-more]');
      if (!more) return;
      e.preventDefault();
      /* a second tap would append the same page twice */
      if (more.dataset.busy) return;
      more.dataset.busy = '1';
      var label = more.textContent;
      more.textContent = more.dataset.loadingLabel || 'Loading…';
      var url = more.href + (more.href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;
      fetch(url).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = root.querySelector('[data-ps-grid-list]');
        var newList = doc.querySelector('[data-ps-grid-list]');
        if (list && newList) { newList.querySelectorAll('.ps-grid__item').forEach(function (li) { list.appendChild(li); }); }
        var wrap = more.parentElement;
        var newMore = doc.querySelector('[data-ps-load-more]');
        if (newMore) wrap.innerHTML = newMore.outerHTML; else wrap.remove();
        if (window.psCardInit) window.psCardInit(root);
        if (window.psWishlist && window.psWishlist.sync) window.psWishlist.sync(root);
        tidyRows();
      }).catch(function () {
        /* leave the button usable so the shopper can try again */
        delete more.dataset.busy;
        more.textContent = more.dataset.retryLabel || label;
      });
    });

    /* ---------- scroll signifier on the category rail ----------
       A tab clipped mid-word at the rail's edge reads as a rendering bug rather
       than an invitation to scroll, so fade whichever edge still has tabs behind
       it. The fade drops away at each end, which is what tells you you've run
       out of tabs. — Arnav, 3 Oct

       Bound on the wrapper, not the scroller: a filter change replaces the
       wrapper's innerHTML, so the .ps-chips element itself does not survive.
       Scroll doesn't bubble but it does capture, hence the `true`. */
    var chipsWrap = root.querySelector('[data-ps-chips]');
    if (chipsWrap) {
      var syncFades = function () {
        var rail = chipsWrap.querySelector('.ps-chips');
        if (!rail) return;
        var max = rail.scrollWidth - rail.clientWidth;
        /* a couple of px of slack: sub-pixel layout never lands exactly on 0/max */
        rail.classList.toggle('has-scroll-start', rail.scrollLeft > 2);
        rail.classList.toggle('has-scroll-end', max > 2 && rail.scrollLeft < max - 2);
      };
      chipsWrap.addEventListener('scroll', syncFades, true);
      window.addEventListener('resize', syncFades);
      if ('MutationObserver' in window) {
        new MutationObserver(syncFades).observe(chipsWrap, { childList: true, subtree: true });
      }
      /* fonts land after first paint and change the rail's width */
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncFades);
      syncFades();
    }

    tidyRows();
  }

  function boot() { document.querySelectorAll('[data-ps-collection]').forEach(init); }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
